import { render, staticRenderFns } from "./MfmDataTable.vue?vue&type=template&id=2fc1b4cc&scoped=true"
import script from "./MfmDataTable.vue?vue&type=script&lang=js"
export * from "./MfmDataTable.vue?vue&type=script&lang=js"
import style0 from "./MfmDataTable.vue?vue&type=style&index=0&id=2fc1b4cc&prod&scoped=true&lang=css"
import style1 from "./MfmDataTable.vue?vue&type=style&index=1&id=2fc1b4cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc1b4cc",
  null
  
)

export default component.exports